import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function LoginPage() {
  const location = useLocation();
  const error = location.state?.error;

  const handleGoogleLogin = () => {
    const redirectUrl = window.location.origin + '/dashboard';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row" data-testid="login-page">
      {/* Left - Login Form */}
      <div className="w-full lg:w-[45%] flex flex-col items-center justify-center px-6 sm:px-8 py-12 lg:py-0 bg-[#09090B]">
        <div className="w-full max-w-md space-y-8 lg:space-y-10">
          {/* Brand */}
          <div>
            <h1 className="font-heading text-4xl font-bold tracking-tight text-white uppercase">
              Emergent <span className="text-blue-500">ATS</span>
            </h1>
            <p className="text-zinc-500 mt-2 text-sm tracking-wider uppercase">Talent Acquisition System</p>
          </div>

          {/* Welcome */}
          <div className="space-y-2">
            <h2 className="text-2xl font-semibold text-white">Welcome back</h2>
            <p className="text-zinc-400 text-base">Sign in with your Emergent account to continue reviewing candidates.</p>
          </div>

          {error && (
            <div className="p-4 rounded-lg bg-red-500/10 border border-red-500/20 text-red-400 text-sm" data-testid="login-error">
              {error}
            </div>
          )}

          {/* Google Login Button */}
          <Button
            data-testid="google-login-btn"
            onClick={handleGoogleLogin}
            className="w-full h-12 bg-white text-zinc-900 hover:bg-zinc-100 font-medium text-sm rounded-lg flex items-center justify-center gap-3 transition-colors"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 01-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Continue with Google
          </Button>

          <p className="text-center text-xs text-zinc-600">
            Only <span className="text-zinc-400">@emergent.sh</span> accounts are allowed
          </p>
        </div>
      </div>

      {/* Right - Visual */}
      <div className="hidden lg:flex lg:w-[55%] relative items-center justify-center overflow-hidden bg-[#0f0f12]">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600/5 to-transparent" />
        <div className="relative text-center px-16 space-y-8">
          <div className="w-24 h-24 mx-auto rounded-2xl bg-blue-500/10 border border-blue-500/20 flex items-center justify-center">
            <svg className="w-12 h-12 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
          </div>
          <h3 className="font-heading text-3xl font-bold text-white uppercase tracking-tight">
            Review. Decide. Hire.
          </h3>
          <p className="text-zinc-500 text-lg max-w-md mx-auto leading-relaxed">
            Swipe through candidates, collaborate with your team, and let AI help you find the perfect match.
          </p>
        </div>
      </div>
    </div>
  );
}
